var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "900" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Voltar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", {
        attrs: {
          title: "Restrições da simulação",
          subtitle: _vm.simulacao.nome_simulacao || ""
        }
      }),
      !_vm.loading && _vm.simulacao.hash_code
        ? _c(
            "div",
            { staticStyle: { "min-height": "300px" } },
            [
              _c("h2", { staticClass: "subhead text-normal" }, [
                _vm._v(" RESTRIÇÕES BÁSICAS ")
              ]),
              _c("Card", [
                _c("div", { staticClass: "row" }, [
                  _vm.simulacao.restricoes.pl
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "P/L simulação",
                              value: _vm.toMoney(_vm.simulacao.restricoes.pl),
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.simulacao.restricoes.perfil
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Perfil",
                              value: _vm.simulacao.restricoes.perfil,
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.simulacao.restricoes.janela_tempo
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Janela de tempo",
                              suffix: "meses",
                              value: _vm.simulacao.restricoes.janela_tempo,
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isManual
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c(
                            "v-radio-group",
                            {
                              attrs: {
                                dense: "",
                                "hide-details": "",
                                label: "Tipos de ativos",
                                value: _vm.simulacao.restricoes.tipo_ativos
                              }
                            },
                            [
                              _c("v-radio", {
                                attrs: {
                                  value: "fundos",
                                  label: "Apenas fundos"
                                }
                              }),
                              _c("v-radio", {
                                attrs: { value: "all", label: "Todos" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.simulacao.restricoes.min_retorno
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-currency-field", {
                            attrs: {
                              label: "Retorno Relativo mín. (μ)",
                              "hide-details": "",
                              value: _vm.simulacao.restricoes.min_retorno,
                              suffix: " %"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.simulacao.restricoes.min_risco
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-currency-field", {
                            attrs: {
                              label: "Volatilidade máx. (σ)",
                              "hide-details": "",
                              value: _vm.simulacao.restricoes.min_risco,
                              suffix: " %"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.simulacao.restricoes.qtd_min
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Minimo de ativos",
                              value: _vm.simulacao.restricoes.qtd_min,
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.simulacao.restricoes.qtd_max
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Maximo de ativos",
                              value: _vm.simulacao.restricoes.qtd_max,
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]),
              _vm.simulacao.restricoes &&
              _vm.simulacao.restricoes.tipo_simulador !== "manual"
                ? _c(
                    "div",
                    [
                      _c("v-divider", { staticClass: "mt-10 mb-10" }),
                      _c("h2", { staticClass: "subhead text-normal" }, [
                        _vm._v(" COMPOSIÇÃO ESTRATÉGICA ")
                      ]),
                      _c("Card", [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            _vm._l(Object.values(_vm.compEstr), function(c) {
                              return _c("div", { staticClass: "row mt-1" }, [
                                _c("div", { staticClass: "col-5 text-right" }, [
                                  _c("small", [
                                    _vm._v(" " + _vm._s(c.name) + " ")
                                  ]),
                                  _c("br"),
                                  _vm.simulacao.restricoes.fgc[
                                    _vm.dicClasse[c.name]
                                  ]
                                    ? _c(
                                        "small",
                                        { staticClass: "text-secondary" },
                                        [_vm._v(" Somente FGC ")]
                                      )
                                    : _vm._e()
                                ]),
                                _c("div", {
                                  style: {
                                    width: "3px",
                                    "background-color": c.color,
                                    "border-radius": "30px"
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 py-0 d-flex align-items-center"
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Valor",
                                        value: _vm.isManual
                                          ? _vm.toPercent(c.percent)
                                          : _vm.toPercent(c.percent * 100),
                                        readonly: "",
                                        dense: "",
                                        "hide-details": ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            }),
                            0
                          ),
                          _c("div", { staticClass: "col-6" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center align-items-center",
                                staticStyle: { height: "100%" }
                              },
                              [
                                _c("apexchart", {
                                  attrs: {
                                    type: "donut",
                                    height: "400",
                                    width: "400",
                                    options: _vm.compEstrOpts,
                                    series: _vm.compEstrData
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.simulacao.restricoes.ativos_fixos &&
              _vm.simulacao.restricoes.ativos_fixos.length
                ? _c("v-divider", { staticClass: "mt-10 mb-10" })
                : _vm._e(),
              _vm.simulacao.restricoes.ativos_fixos &&
              _vm.simulacao.restricoes.ativos_fixos.length
                ? _c("h2", { staticClass: "subhead text-normal" }, [
                    _vm._v(" ATIVOS FIXADOS ")
                  ])
                : _vm._e(),
              _vm.simulacao.restricoes.ativos_fixos &&
              _vm.simulacao.restricoes.ativos_fixos.length
                ? _c("Card", [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("v-simple-table", {
                            attrs: { "fixed-header": "", height: "400" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { staticClass: "text-left" },
                                            [_vm._v("Ativos fixados")]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-left",
                                              staticStyle: {
                                                "min-width": "150px"
                                              }
                                            },
                                            [_vm._v("Classe")]
                                          ),
                                          _vm.modo === "subclasse"
                                            ? _c(
                                                "th",
                                                {
                                                  staticClass: "text-left",
                                                  staticStyle: {
                                                    "min-width": "150px"
                                                  }
                                                },
                                                [_vm._v(" Subclasse ")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-left",
                                              staticStyle: {
                                                "min-width": "150px"
                                              }
                                            },
                                            [_vm._v(" P/L fixado ")]
                                          )
                                        ])
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.simulacao.restricoes.ativos_fixos,
                                          function(ativo) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm._v(_vm._s(ativo.nome_ativo))
                                              ]),
                                              _c("td", [
                                                _vm._v(_vm._s(ativo.classe))
                                              ]),
                                              _vm.modo === "subclasse"
                                                ? _c("td", [
                                                    _vm._v(
                                                      _vm._s(ativo.subclasse)
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(_vm.toMoney(ativo.pl))
                                                )
                                              ])
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              410450015
                            )
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.loading
        ? _c(
            "v-row",
            {
              staticStyle: { "min-height": "300px" },
              attrs: { justify: "center", align: "center" }
            },
            [
              _c(
                "div",
                { staticClass: "text-center ma-12 w-100 v-application" },
                [
                  _c("v-progress-circular", {
                    attrs: { size: 50, indeterminate: "", color: "primary" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }